export default "__VITE_ASSET__DqJaFCtE__"